var exports = {
  "kL": "EmojiTooltipContent.module__container___QUcyTm",
  "Zg": "EmojiTooltipContent.module__emoji___QUcyTm",
  "FS": "EmojiTooltipContent.module__textContainer___QUcyTm",
  "Lq": "EmojiTooltipContent.module__loading___QUcyTm",
  "W$": "EmojiTooltipContent.module__subtext___QUcyTm",
  "vW": "EmojiTooltipContent.module__inner___QUcyTm",
};

module.exports = exports;
